import { HttpMethod } from "../http-request";
import { ApiEndpointSpecification } from "./types";
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_WHITELIST_ZONE } from "./url-constants";

type GetWhiteListZoneEndpointSpecifications = ApiEndpointSpecification;
export const GetWhiteListZoneEndpointSpecification: GetWhiteListZoneEndpointSpecifications = {
    url: GET_WHITELIST_ZONE,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'GetWhitelistZoneRequestParams',
    requestBodySchemaName: 'GetWhitelistZoneRequestBody',
    okResponseSchemaName: 'GetWhitelistZoneOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
}

export const invokeWhiteListZoneDetails = Helpers.makeApiRequestFn<
    Types.GetWhiteListZoneRequestParams,
    Types.GetWhiteListZoneRequestBody,
    Types.GetWhitelistZoneOkResponse>(GetWhiteListZoneEndpointSpecification)
